<template>
  <div class="home">
    <h1 class="title is-4">
      ConfCloud befindet sich aktuell in einer geschlossenen Testphase.
    </h1>
    <h2 class="subtitle is-5">Anfragen: info@confcloud.de</h2>
  </div>
</template>

<script>
export default {
  name: "Home",
  beforeMount() {
    if (localStorage.getItem("jwt")) this.$router.push("/konto");
  }
};
</script>

<style>
.home {
  height: 75vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
